import React, { FunctionComponentElement, useState } from "react";
import { NodeInputProps } from "./index";
import { InputText } from "primereact/inputtext";
import { ErrorDefaultValueWidget } from "../error/errorDefaultValueWidget";
import styles from "./Form.module.scss"

export const StringInput = (
  props: NodeInputProps
): FunctionComponentElement<NodeInputProps> => {
  const [incorrectDefaultValue, setIncorrectDefaultValue] = useState<boolean>(false);
  const [isValid, setIsValid] = useState(true);

  const verifyType = (value: any) => {
    return typeof value === "string";
  };

  const [valueWidget, setValueWidget] = useState(() => {
    if (props.value) return props.value;
    if (props.defaultValue) {
      if (verifyType(props.defaultValue)) return props.defaultValue;
      else setIncorrectDefaultValue(true);
    }
    return undefined;
  });

  return (
    <div>
      <ErrorDefaultValueWidget displayError={incorrectDefaultValue} />
      <InputText
        value={valueWidget}
        placeholder={props.placeholder}
        onChange={(e) => {
          setIsValid(props.regex ? props.regex.test(e.target.value) : true);
          props.onChange(e.target.value);
          setValueWidget(e.target.value);
          setIncorrectDefaultValue(false);
        }}
        disabled={props.disabled}
        pattern={props.regex?.source}
        className={isValid ? "" : 'p-invalid'}
      />
      {!isValid && props.regex_msg && <div className={styles['regex-message']}>{props.regex_msg}</div>}
    </div>
  );
};
